import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { useApiSDK } from '../../contexts/apiSdkContext';
import { AppContext } from '../../contexts/app-context';

type TDeviceDeleteHook = {
  isError: boolean;
  isLoading: boolean;
  mutate: UseMutationResult<void, unknown, TDeleteDevice, unknown>['mutate'];
};

type TDeleteDevice = {
  id: string;
  deviceTypeId: string;
};

function useDeleteDevice(): TDeviceDeleteHook {
  const sdk = useApiSDK();
  const appContext = useContext(AppContext);
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { isError, isLoading, mutate } = useMutation({
    mutationFn: (obj: TDeleteDevice) => sdk.devices.delete(obj.id),
    onSuccess: async (_contexts, variables) => {
      await queryClient.invalidateQueries(['device-by-device-type']);
      await queryClient.invalidateQueries(['devices']);
      appContext?.crudAlert('delete', 'device', 'default');
      navigate(`/devices/${variables.deviceTypeId}`);
    },
    onError: async (error: any) => {
      if (error) {
        const responseErrors = error.response.data.errors;
        responseErrors.forEach((err: { message: string; description: string }) => {
          appContext?.systemAlert('error', err.description);
        });
      }
    },
  });

  return { isError, isLoading, mutate };
}

export { useDeleteDevice, TDeleteDevice };
